import gql from 'graphql-tag';

import { buildQueryHook } from '../../../utils/buildQueryHook';
import {
  SearchBidPostings_homework_searchBidPostings_bidPostings as BidPostings,
  SearchBidPostings,
  SearchBidPostingsVariables,
} from '../../athena/types/SearchBidPostings';
import { BidPostingFields } from '../../fragments/homework/BidPosting';

export const SEARCH_BID_POSTINGS = gql`
  query SearchBidPostings(
    $markets: [String!]
    $bidPostingStatuses: [String!]
    $projectIds: [String!]
    $pagination: OdProtosCommonPagination_PaginationRequestInput
  ) {
    homework {
      searchBidPostings(
        input: {
          markets: $markets
          bidPostingStatuses: $bidPostingStatuses
          projectIds: $projectIds
          pagination: $pagination
        }
      ) {
        pagination {
          cursors
          hasNextPage
          hasPreviousPage
        }
        bidPostings {
          ...BidPostingFields
        }
      }
    }
  }
  ${BidPostingFields}
`;

export default buildQueryHook<SearchBidPostings, SearchBidPostingsVariables, BidPostings[] | null>(
  SEARCH_BID_POSTINGS,
  {
    wrangler: (data) => data?.homework?.searchBidPostings?.bidPostings || null,
  },
);
